/* eslint no-console: 0 */
import Vue from 'vue'
import DetectLocation from '@/shared/detect_location.vue'
import auth_mixin from '@/shared/auth_mixin'

Vue.mixin(auth_mixin)

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '#detect',
    components: { DetectLocation },
  })
})
